export default __webpack_public_path__ + "static/us1-e0083fcb67e93d55d946159419c0da1d.svg";